import { render, staticRenderFns } from "./expresscost-deducted.vue?vue&type=template&id=00242e92&scoped=true"
import script from "./expresscost-deducted.vue?vue&type=script&lang=ts"
export * from "./expresscost-deducted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00242e92",
  null
  
)

export default component.exports